import React, { useContext } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import classnames from 'classnames/bind';
import Cookies from 'js-cookie';

import UcpIcon from '@assets/images/ucp.svg';
import { Button } from '@components';
import { CartButton } from '../CartButton';
import { Icon } from 'gd-design-library';
import { ROUTES } from '@constants';
import { ACCESS_TOKEN_COOKIE } from '@constants/auth';
import { getMiddlewareOrigin } from '@/lib/ucp/middleware-origin';
import { UserContext } from 'utils';
import { isFeatureEnabled, FEATURES } from '@utils/featureFlags';
import styles from './HeaderActions.module.scss';

const CN = 'header-actions';
const buttonClassName = `${CN}--button`;

const cx = classnames.bind(styles);

interface HeaderActionsProps {
  onCartClick: () => void;
  onClose?: () => void;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({ onCartClick, onClose }) => {
  const { push } = useRouter();
  const { user } = useContext(UserContext);

  const appUrl = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

  const handleUcpClick = (): void => {
    const ctToken = Cookies.get(ACCESS_TOKEN_COOKIE);
    if (user && ctToken) {
      const redirect = encodeURIComponent(`${appUrl}/ucp/api/auth/sso`);
      window.location.href =
        `${getMiddlewareOrigin()}/sso/exchange` +
        `?token=${encodeURIComponent(ctToken)}&redirect=${redirect}`;
    } else {
      window.location.href = `${appUrl}/ucp`;
    }
  };

  return (
    <div className={ cx(CN) }>
      { isFeatureEnabled(FEATURES.UCP) && (
        <Button
          isIcon
          variant='inherit'
          className={ cx(buttonClassName) }
          onClick={ handleUcpClick }
          aria-label='Open UCP AI Shopping'
          title='UCP AI Shopping'
        >
          <Image
            src={ UcpIcon.src }
            alt='UCP'
            width={ 28 }
            height={ 28 }
          />
        </Button>
      ) }
      <Button
        isIcon
        variant='inherit'
        className={ cx(buttonClassName) }
        aria-label='View favorites'
      >
        <Icon name='favorite' width={ 24 } height={ 24 } />
      </Button>
      <CartButton onCartClick={ onCartClick } onClose={ onClose } />
      <Button
        isIcon
        variant='inherit'
        className={ cx(buttonClassName) }
        onClick={ ():void => {
          onClose?.();
          push(user ? ROUTES.myAccount : ROUTES.signIn);
        } }
        aria-label={ user ? 'View account' : 'Sign in' }
      >
        <Icon name='accountCircle' width={ 28 } height={ 28 } />
      </Button>
    </div>
  );
};
